import { render, staticRenderFns } from "./tasksTodayGoods copy.vue?vue&type=template&id=96d13fe2&"
import script from "./tasksTodayGoods copy.vue?vue&type=script&lang=js&"
export * from "./tasksTodayGoods copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports